import _ from 'lodash';
import produce, { Draft } from 'immer';

import { IExperimentList, ValidationState } from '@models';
import {
  IExperimentListsState,
  ExperimentListActionTypes,
  EXPERIMENTS_FILE_VALIDATION_SUCCEEDED,
  EXPERIMENTS_FILE_VALIDATION_FAILED,
  VALIDATING_EXPERIMENTS_FILE,
  SELECTED_EXPERIMENTS_FILE,
  DISCARD_EXPERIMENT_LIST,
  IExperimentListValidationSucceededAction,
  IExperimentListValidationFailedAction,
  ISelectedExperimentsFileAction,
  START_UPLOAD,
  START_UPLOAD_FAILED,
  START_UPLOAD_COMPLETED,
  CLEAR_EXPERIMENT_LIST,
} from '@store/types/uploads/experimentList';

import { IActionString } from '@store/types/common';
import { RequestStatus } from '@store/types/request';

const initialExperimentFileValidationState: IExperimentListsState = {
  experimentLists: [],
};

export const experimentListsReducer = produce(
  (
    state: Draft<IExperimentListsState>,
    action: ExperimentListActionTypes
  ): void => {
    switch (action.type) {
      case SELECTED_EXPERIMENTS_FILE:
        {
          const { id, file } = (action as ISelectedExperimentsFileAction)
            .payload;
          const experimentList: IExperimentList = {
            id,
            file,
            errors: [],
            status: ValidationState.none,
            startUploadStatus: RequestStatus.none,
          };
          state.experimentLists.unshift(experimentList);
        }
        break;
      case VALIDATING_EXPERIMENTS_FILE:
        {
          const experimentList = _.find(
            state.experimentLists,
            (x) => x.id === action.payload
          );
          if (experimentList) {
            experimentList.status = ValidationState.inProgress;
          }
        }
        break;
      case EXPERIMENTS_FILE_VALIDATION_SUCCEEDED:
        {
          const { id, results } = (
            action as IExperimentListValidationSucceededAction
          ).payload;
          const experimentList = _.find(
            state.experimentLists,
            (x) => x.id === id
          );
          if (experimentList) {
            experimentList.experiment = results;
            experimentList.status = ValidationState.passed;
          }
        }
        break;
      case EXPERIMENTS_FILE_VALIDATION_FAILED:
        {
          const { id, errors } = (
            action as IExperimentListValidationFailedAction
          ).payload;
          const experimentList = _.find(
            state.experimentLists,
            (x) => x.id === id
          );
          if (experimentList) {
            experimentList.errors = errors;
            experimentList.status = ValidationState.failed;
          }
        }
        break;
      case DISCARD_EXPERIMENT_LIST:
        {
          const id = (action as IActionString).payload;
          state.experimentLists = _.reject(
            state.experimentLists,
            (x) => x.id === id
          );
        }
        break;
      case CLEAR_EXPERIMENT_LIST:
        state.experimentLists = [];
        break;
      case START_UPLOAD:
        {
          const id = (action as IActionString).payload;
          const experimentList = _.find(
            state.experimentLists,
            (x) => x.id === id
          );
          if (experimentList) {
            experimentList.startUploadStatus = RequestStatus.inProgress;
          }
        }
        break;
      case START_UPLOAD_FAILED:
        {
          const id = (action as IActionString).payload;
          const experimentList = _.find(
            state.experimentLists,
            (x) => x.id === id
          );
          if (experimentList) {
            experimentList.startUploadStatus = RequestStatus.failed;
          }
        }
        break;
      case START_UPLOAD_COMPLETED:
        {
          const id = (action as IActionString).payload;
          const experimentList = _.find(
            state.experimentLists,
            (x) => x.id === id
          );
          if (experimentList) {
            experimentList.startUploadStatus = RequestStatus.completed;
          }
        }
        break;
    }
  },
  initialExperimentFileValidationState
);
